// Every action a person can take in the admin, and the permission it needs.
//
// ONE TABLE, ONE CHECK (owner, 2026-09-25, B5): « every action button — send,
// approve payment, edit a Brain rule, flip a switch, change a price, delete —
// goes through one permission check, even if today that check always says yes
// for admin ». A manager role later is an edit to this table, not to screens.
//
// Guard: src/lib/actions.test.ts
import { usePermissions } from './permissionsStore';

export const ACTION_PERMISSION = {
  'conversation.send': 'whatsapp.manage',
  'conversation.send_media': 'whatsapp.manage',
  'conversation.pause': 'whatsapp.manage',
  'conversation.resume': 'whatsapp.manage',
  // « Supprimer pour tout le monde » (2026-09-29): the same chat work as sending.
  'conversation.delete_message': 'whatsapp.manage',
  // The Inbox — working the chats.
  'inbox.handle': 'whatsapp.manage',
  'inbox.ignore': 'whatsapp.manage',
  'inbox.snooze': 'whatsapp.manage',
  'inbox.undo': 'whatsapp.manage',
  // ⚠️ SWITCHES ARE SETTINGS, NOT CHAT WORK (Zammad's split, research
  // 2026-09-25): a manager can work the Inbox all day without being able to
  // turn the agent off for every customer.
  'settings.agent_switch': 'settings.manage',
  // The order page's two shortcuts (parcel scanner, 2026-10-01). The scanner
  // moves statuses; the 3D preview follows the permission that guards the
  // preview link card (worker /preview-link/notes).
  'order.open_scanner': 'orders.edit_status',
  'order.open_preview': 'production.preview_links',
  // « L'agent modifie l'album » + ticking the client's requests (2026-10-03):
  // album edits, so the permission of every other album edit by a person
  // (worker routes/clientRequests.ts).
  'order.agent_album_edits': 'editor.access',
} as const;

export type AdminAction = keyof typeof ACTION_PERMISSION;

/** Pure: may this set of permissions do this action? Loading (null) = no. */
export function canDo(perms: Set<string> | null, action: AdminAction): boolean {
  if (!perms) return false;
  return perms.has('*') || perms.has(ACTION_PERMISSION[action]);
}

/** Hook: the one check every action button asks. */
export function useCan(): (action: AdminAction) => boolean {
  const { perms } = usePermissions();
  return (action) => canDo(perms, action);
}
